module.exports = __webpack_public_path__ + "img/earth.960_480.532b52d9.jpg";